import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

// import AlertDialog from '../../modals/alertDialog';
import BasicButton from '../../buttons/basicButton';
import BreadCrumb from '../../fields/breadCrumb';
import ProgramsList from './programsList';
import CustomSnackbar from '../../feedback/customSnackbar';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { deleteClinician, getClinicians, getPrograms } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ListPrograms({ lang, handleChangeLang }) {
  const sessionContext = useContext(SessionContext);

  const [programsList, setProgramsList] = useState([]);
  // const [cliniciansList, setCliniciansList] = useState([]);
  // const [selectedClinicians, setSelectedClinicians] = useState([]);
  const [feedbackType, setFeedbackType] = useState('');
  const [showDrawer, setShowDrawer] = useState(false);
  // const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const getProgramsFromServer = async () => {
      setShowLoading(true);
      const response = await getPrograms(sessionContext.userToken);
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat
        setProgramsList(response.data.programs);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getProgramsFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  /* const deleteProgramsData = async () => {
    setShowLoading(true);
    // Esborram usuaris
    // const responseDelete = await deleteClinician(selectedClinicians[0].id, sessionContext.userToken);
    const responseDelete = await Promise.all(selectedClinicians.map((element) => deleteClinician(element.id, sessionContext.userToken)));

    // Comprovam si dins les respostes n'hi ha alguna d'erronia
    const allOk = responseDelete.map((answer) => {
      if (answer.status && answer.status === 200) return 'ok';
      return 'error';
    });
    const idx = allOk.indexOf('error');
    if (idx > -1) { // Al manco hi ha 1 error
      setFeedbackType('error');
      setShowFeedback(true);
    } else { // No hi ha cap error
      setFeedbackType('success');
      setShowFeedback(true);
    }
    setSelectedClinicians([]);

    // Obtenim llistat actualitzat dels usuaris
    const responseGet = await getClinicians(sessionContext.userToken);
    setShowLoading(false);
    if (responseGet.status === 200) { // Tenim llistat
      setCliniciansList(responseGet.data.clinicians);
    } else if (responseGet === 400) { // Error amb les dades
      console.log('Error 400');
    } else { // Login KO. Altres errors
      console.log(responseGet);
    }
  }; */

  const editProgram = (id) => {
    history.push(`/${sessionContext.role.toLowerCase()}/editProgramInfo/${id}`);
  };

  const newProgram = () => {
    history.push(`/${sessionContext.role.toLowerCase()}/newProgramInfo`);
  };

  /* const selectedClinician = (id, username) => {
    const selectedCliniciansCopy = selectedClinicians.slice();
    // Cercam si dins selectedCliniciansCopy hi ha el valor de clinician
    const idx = selectedCliniciansCopy.findIndex((item) => item.id === id);
    if (idx < 0) selectedCliniciansCopy.push({ id, username }); // Si idx és -1 vol dir que no ha trobat el valor, l'afegim a la taula
    else selectedCliniciansCopy.splice(idx, 1); // L'ha trobat l'eliminam de la taula
    setSelectedClinicians(selectedCliniciansCopy);
  }; */

  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  /* const manageDeleteAlertAnswer = (agree) => {
    setShowDeleteAlert(false);
    if (agree) deleteProgramsData();
  }; */

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawer type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} handleGotoScreen={(screen) => gotoScreen(screen)} />
      {/* <AlertDialog open={showDeleteAlert} handleClose={(agree) => manageDeleteAlertAnswer(agree)} title={translations['_deleteProgramsAlertTitle']} message={translations['_deleteProgramsAlertMessage']} data={selectedClinicians} field=++ /> */}
      <CustomSnackbar show={showFeedback} handleCloseFeedback={(show) => setShowFeedback(show)} type={feedbackType} message={(showFeedback && translations[`_${feedbackType}DeleteClinician`]) || ''} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{sessionContext.role === 'Admin' ? translations['_allPrograms'] : translations['_programs']}</Typography>
              </Grid>
              <Grid item>
                {sessionContext.role === 'Admin' && <BasicButton handleClick={() => newProgram()} type='accept' text={translations['_newProgram']} />}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs={12}>
                <ProgramsList
                  programsData={programsList}
                  handleEditProgram={(program) => editProgram(program)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListPrograms);

// Indica i controla els props que se han de passar al component
ListPrograms.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};
